/**
 * Qué ventas de un lote de «Registrar en Shalom» no se tocan: las que ya tienen guía, y las que ya van con otro
 * transportista.
 *
 * 🚨 UNA VENTA QUE YA VA CON OTRO TRANSPORTISTA NO SE REGISTRA EN SHALOM DE GOLPE (auditoría de North Express,
 *    12-oct). El lote no miraba el transportista: una venta de North Express o GSG (motorizado, contra entrega)
 *    recibía una agencia de Lima y se registraba en Shalom, y al cambiar el transportista la base la pasaba a
 *    agencia —sin contra entrega—. Eso se cambia en la venta, a propósito, no en un lote.
 */
export interface EnvioDelLote {
  order_id: string;
  tracking_number: string | null;
  carrier: string | null;
  status: string | null;
}

export function lasQueYaVanConOtroTransportista(
  ventas: readonly { id: string; courier_tenant_id?: string | null }[],
  envios: readonly EnvioDelLote[],
): { conGuia: Set<string>; conOtro: Map<string, string> } {
  const conGuia = new Set(envios.filter((e) => e.tracking_number).map((e) => e.order_id));
  const conOtro = new Map(ventas.filter((v) => v.courier_tenant_id).map((v) => [v.id, 'el courier de Smarty Drop']));
  for (const e of envios) {
    if (e.status !== 'cancelled' && e.carrier?.trim() && !/shalom/i.test(e.carrier)) conOtro.set(e.order_id, e.carrier.trim());
  }
  return { conGuia, conOtro };
}
